import { congnitoConfiguration } from '../../configs/AWS';
import { gcipConfiguration } from '../../configs/GCIP';
import { getEnv } from '../../libs/helper/HelperFunctions';
import { storage, STORAGE_CONSTANTS } from '../../libs/services/LocalStorage';

export const LoginLabels = {
  loginAsExternalUser: 'Login as External User',
  needHelp: 'Need Help?',
  signUpText: 'SignUp for External user',
  ssoLoginText: 'Login with SSO',
  externalUserLoginText: 'Login as External user',
  requiredEmailErrorMessage: 'Please input your username!',
  requiredPasswordErrorMessage: 'Please input your password!',
  succesfulLoginText: 'Logged in Successfully',
  success: 'Success!!',
  error: 'Error!!',
  loginFailed: 'Login Failed',
  loaderName: 'Authenticating!!',
};
export const FooterLabels = {
  year: ' © 2022. See',
  terms: ' Terms of Use',
  privacy: ' Privacy',
  forMore: ' for more information. | ',
};

// --- Cognito: getAuthURL (uncomment to rollback to Cognito) ---
// export const getAuthURL = () => {
//   const environment = getEnv();
//   const COGNITO = congnitoConfiguration(environment);
//   const url = `${COGNITO.DOMAIN}/oauth2/authorize?redirect_uri=${COGNITO.REDIRECT_SIGN_IN}&response_type=${COGNITO.RESPONSE_TYPE}&client_id=${COGNITO.APP_CLIENT_ID}`;
//   return url;
// };

interface IGCIPCreateAuthUriResponse {
  authUri: string;
  sessionId: string;
}

export const initiateGCIPSignIn = async (): Promise<void> => {
  const environment = getEnv();
  const gcip = gcipConfiguration(environment);

  const url = `https://identitytoolkit.googleapis.com/v1/accounts:createAuthUri?key=${gcip.API_KEY}`;
  const payload = {
    providerId: `oidc.${gcip.PROVIDER_ID}`,
    continueUri: gcip.REDIRECT_SIGN_IN,
    tenantId: gcip.TENANT_ID,
  };

  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(`GCIP createAuthUri failed with status: ${response.status}`);
  }

  const data = (await response.json()) as IGCIPCreateAuthUriResponse;
  storage.setItem(STORAGE_CONSTANTS.gcipSessionId, data.sessionId);
  window.location.replace(data.authUri);
};

export const getCwbAuthUrl = () => {
  const environment = getEnv();
  const COGNITO = congnitoConfiguration(environment).CWB;
  const url = `${COGNITO.DOMAIN}/oauth2/authorize?redirect_uri=${COGNITO.REDIRECT_SIGN_IN}&response_type=${COGNITO.RESPONSE_TYPE}&client_id=${COGNITO.APP_CLIENT_ID}`;
  return url;
};
